export enum CallCentreLicenceTypes {
    NONE = 'None',
    BASIC = 'Call Center Basic',
    STANDARD = 'Call Center Standard',
    PREMIUM = 'Call Center Premium'
}
